import actions, { cohortChart } from './constants';

export const fetchCohortBarChartQuery = (category, code, queryUUID, dictionaryCode) => ({
  type: actions.FETCH_COHORT_VISUALISATION_BAR_QUERY,
  category,
  code,
  chartType: cohortChart.BAR,
  queryUUID,
  dictionaryCode,
});

export const fetchCohortStackedBarChartQuery = (category, code, queryUUID, dictionaryCode) => ({
  type: actions.FETCH_COHORT_VISUALISATION_STACKED_BAR_QUERY,
  category,
  code,
  chartType: cohortChart.STACKED_BAR,
  queryUUID,
  dictionaryCode,
});

export const fetchCohortBoxPlotQuery = (category, code, queryUUID, dictionaryCode) => ({
  type: actions.FETCH_COHORT_VISUALISATION_BOX_PLOT_QUERY,
  category,
  code,
  chartType: cohortChart.BOX_PLOT,
  queryUUID,
  dictionaryCode,
});

export const fetchCohortHistogramQuery = (category, code, queryUUID, dictionaryCode) => ({
  type: actions.FETCH_COHORT_VISUALISATION_HISTOGRAM_QUERY,
  category,
  code,
  chartType: cohortChart.HISTOGRAM,
  queryUUID,
  dictionaryCode,
});

export const refreshCohortVisualisation = (category, code, queryUUID) => ({
  type: actions.REFRESH_COHORT_VISUALISATION,
  category,
  code,
  queryUUID,
});

export const showCohortVisualisation = (category, code, chartType, queryUUID, result) => ({
  type: actions.SHOW_COHORT_VISUALISATION,
  category,
  code,
  chartType,
  queryUUID,
  result,
});

export const showCohortVisualisationError = (category, code, chartType, queryUUID, error) => ({
  type: actions.SHOW_COHORT_VISUALISATION_ERROR,
  category,
  code,
  chartType,
  queryUUID,
  error,
});

export const toggleCohortVisualisationSelected = (category, code, chartType) => ({
  type: actions.TOGGLE_COHORT_VISUALISATION_SELECTED,
  category,
  code,
  chartType,
});

export const changeCohortVisualisationXAxis = (category, code, chartType, name, label) => ({
  type: actions.CHANGE_COHORT_VISUALISATION_X_AXIS,
  category,
  code,
  chartType,
  name,
  label,
});

export const changeCohortVisualisationYAxis = (category, code, chartType, name, label) => ({
  type: actions.CHANGE_COHORT_VISUALISATION_Y_AXIS,
  category,
  code,
  chartType,
  name,
  label,
});

export const changeCohortVisualisationBins = (category, code, chartType, bins) => ({
  type: actions.CHANGE_COHORT_VISUALISATION_BINS,
  category,
  code,
  chartType,
  bins,
});
